import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check, ChevronDown, Globe } from "lucide-react";
import { useLang } from "../i18n";

const LANGS = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
];

export const LanguageSelector = ({ compact = false }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div ref={ref} className="relative" data-testid="language-selector">
      <button
        data-testid="language-selector-button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full border border-white/15 px-3.5 py-2 text-[12px] font-semibold uppercase tracking-[0.1em] text-white/80 transition-colors duration-300 hover:border-white/40 hover:text-white"
      >
        <Globe size={14} className="text-primary" />
        {compact ? current.code.toUpperCase() : current.label}
        <ChevronDown
          size={13}
          className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.18 }}
            className="absolute right-0 top-full z-50 mt-2 w-44 overflow-hidden rounded-2xl border border-white/10 bg-[#071c40] p-1.5 shadow-2xl shadow-black/50"
            data-testid="language-selector-menu"
          >
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`language-option-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center justify-between rounded-xl px-4 py-2.5 text-left text-sm transition-colors duration-200 ${
                  lang === l.code ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
                }`}
              >
                {l.label}
                {lang === l.code && <Check size={14} className="text-primary" />}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
